import { createGlobalStyle, styled } from "styled-components";

export const Button = styled.button`
	background: #003a50;
	border-radius: 30px;
	height: 48px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	cursor: pointer;
	color: #ffffff;
	text-transform: capitalize;
	font-size: 16px;
`;

export const StyledContainer = styled.div`
	padding: 20px 35px;
	color: #555555;
	margin-bottom: 30px;
`;

export const GlobalStyle = createGlobalStyle`	
/* Reset Styles */
*,
:after,
:before {
	border: 0 solid #e5e7eb;
	box-sizing: border-box;
}
:after,
:before {
	--tw-content: "";
}
html {
	-webkit-text-size-adjust: 100%;
	-webkit-font-feature-settings: normal;
	font-feature-settings: normal;
	font-variation-settings: normal;
	line-height: 1.5;
	tab-size: 4;
}

hr {
	border-top-width: 1px;
	color: inherit;
	height: 0;
}
abbr:where([title]) {
	-webkit-text-decoration: underline dotted;
	text-decoration: underline dotted;
}
h1,
h2,
h3,
h4,
h5,
h6 {
	font-size: inherit;
	font-weight: inherit;
}
a {
	color: inherit;
	text-decoration: inherit;
}
b,
strong {
	font-weight: bolder;
}
code,
kbd,
pre,
samp {
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
	font-size: 1em;
}
small {
	font-size: 80%;
}
sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: initial;
}
sub {
	bottom: -0.25em;
}
sup {
	top: -0.5em;
}
table {
	border-collapse: collapse;
	border-color: inherit;
	text-indent: 0;
}
button,
input,
optgroup,
select,
textarea {
	color: inherit;
	font-family: inherit;
	font-size: 100%;
	font-weight: inherit;
	line-height: inherit;
	margin: 0;
	padding: 0;
}
button,
select {
	text-transform: none;
}

:-moz-focusring {
	outline: auto;
}
:-moz-ui-invalid {
	box-shadow: none;
}
progress {
	vertical-align: initial;
}
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}
[type="search"] {
	appearance: textfield;
	-webkit-appearance: textfield;
	outline-offset: -2px;
}
::-webkit-search-decoration {
	-webkit-appearance: none;
}
::-webkit-file-upload-button {
	-webkit-appearance: button;
	font: inherit;
}
summary {
	display: list-item;
}
blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
	margin: 0;
}
fieldset {
	margin: 0;
}
fieldset,
legend {
	padding: 0;
}
menu,
ol,
ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
textarea {
	resize: vertical;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
	color: #9ca3af;
	opacity: 1;
}
input::placeholder,
textarea::placeholder {
	color: #9ca3af;
	opacity: 1;
}
[role="button"],
button {
	cursor: pointer;
}
:disabled {
	cursor: default;
}
audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
	display: block;
	/* vertical-align: middle; */
}
img,
video {
	/* height: auto; */
	max-width: 100%;
}
[hidden] {
	display: none;
}
`;
